import React from 'react';
import { generateBem } from '../../../utils/generateBem';

import './TestimonialsList.scss';

const bem = generateBem('Testimonials');

const Testimonial = ({
  className,
  isBackgroundShowing,
  isLogoTall,
  isWide,
  name,
  src,
  text,
  subtitleOne,
  subtitleTwo,
  title,
  style,
}) => (
  <div className={`${bem('item')} ${className || ''}`}>
    <div className={bem(['itemRow', isLogoTall ? 'itemRow--tall' : null])}>
      <div
        className={bem([
          'itemLogo',
          isWide && 'itemLogo--wide',
          isBackgroundShowing && 'itemLogo--background',
        ])}
      >
        <img style={style} src={src} alt={`logo-${title}`} />
      </div>
      <div className={bem('itemDivider')} />
      <h4>
        <b>{subtitleOne}</b>
        <span>{subtitleTwo}</span>
      </h4>
    </div>
    {!!text && (
      <div className={bem('itemContent')}>
        <p>
          <em>
            {`"${text}"`}
            <span>{`- ${name} (${title})`}</span>
          </em>
        </p>
      </div>
    )}
  </div>
);

export const TestimonialsList = ({ listItems }) => {
  return (
    <section className={bem('wrapper')}>
      <h2 className={bem('header')}>
        <span>Trusted By</span>
        <b>10K+</b>
        <span>Private Capitalists</span>
      </h2>
      <div className={bem('items')}>
        {listItems.map((item, index) => (
          <Testimonial key={`testimonial-${index}`} {...item} />
        ))}
      </div>
    </section>
  );
};
